export default __webpack_public_path__ + "static/media/Icon-user-plus.c40c1714.svg";